<template>
  <div class="loading-container">
    <img
      src="@/assets/img/loading.svg"
      alt="loading"
      class="loading scaled-image"
    />
  </div>
</template>
<style>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.scaled-image {
  transform: scale(1.25);
  transition: transform 0.3s ease;
}
</style>
<script>
"use strict";

import { Logger } from "@/logging";
import { generatePaymentUUID, getPaymentUUID } from "@/helper/index.js";
const logger = new Logger("PayPalCardPurchase");

const endpoints = require("@/api/endpoints");

export default {
  name: "PayPalCardPurchase",
  created() {
    generatePaymentUUID();
  },
  async mounted() {
    this.paypalPayButtonClicked();
  },
  data() {
    return {
      loading: true,
      paymentData: {},
    };
  },
  methods: {
    async proceedWithPayPal(
      product_id,
      product_type,
      savedPaymentTokenId = null,
      isSavePaymentTokenPermission = false
    ) {
      this.paymentData = {
        idempotency_key: getPaymentUUID(),
        product_id: product_id,
        product_type: product_type,
        ...(savedPaymentTokenId != null
          ? { vault_id: savedPaymentTokenId }
          : { is_vault_store: isSavePaymentTokenPermission }),
        paypal_session_id: null,
      };

      endpoints
        .paypal_payment(this.$axios, this.paymentData)
        .then((paymentPaypalResponse) => {
          const data = paymentPaypalResponse.data;

          generatePaymentUUID();

          this.loading = false;

          if (paymentPaypalResponse.status == 200) {
            window.location.href = data.redirect_url;
            return;
          } else if (data.error) {
            this.$toast.error(data.error.message);
          }
        })
        .catch((response) => {
          logger.debugError(
            "Unexpected PayPal exception caught",
            this.paymentData,
            response
          );
          this.$toast.error(this.$t("errors.general_error"));

          this.loading = false;
        });
    },
    async paypalPayButtonClicked() {
      let product_id = this.$route.query.product_id;
      let product_type = this.$route.query.product_type
        ? parseInt(this.$route.query.product_type)
        : 0;
      await this.proceedWithPayPal(product_id, product_type, null, true);
    },
  },
};
</script>
